import graphAxios from "../utils/graph-axios";
import { getFbAccessToken } from "../utils/helpers";

const getCampaigns = (adAccount) => {
  const fbAccessToken = getFbAccessToken();

  return graphAxios.get(
    `/${adAccount}/campaigns?fields=name,status,start_time,stop_time,created_time,updated_time,account_id,special_ad_category,objective,daily_budget,lifetime_budget,budget_remaining,spend_cap,ad_strategy_group_id&limit=10`,
    {
      params: {
        access_token: fbAccessToken,
      },
    },
  );
};

const insights = ({ id, time_range }) => {
  const fbAccessToken = getFbAccessToken();

  return graphAxios.get(`/${id}/insights`, {
    params: {
      access_token: fbAccessToken,
      time_range,
    },
  });
};

const CampaignAPI = {
  getCampaigns,
  insights,
};
export default CampaignAPI;
